import { StyledProps } from 'styled-components'
import styled from 'styled-components/native'

import { Box, BoxBorder } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { SpacingTypes, ThemeColor } from 'utils/themes/types'

import { ButtonSizeTypes } from './types'

export type StyledButtonContentProps = StyledProps<{
  border?: BoxBorder
  borderRadius?: SpacingTypes
  disabled?: boolean
  disabledType: ThemeColor
  fullWidth?: boolean
  hasTitle?: boolean
  pressed?: boolean
  size?: ButtonSizeTypes
  type: ThemeColor
}>

export const StyledButtonContent = styled(Box)<StyledButtonContentProps>`
  ${({ theme, type }) => (type ? `background-color: ${theme.colors[type]};` : null)}
  border-radius: ${({ theme, borderRadius }) =>
    borderRadius ? theme.spacing[borderRadius] : theme.borderRadius.xl}px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  align-items: center;
  justify-content: center;
  ${({ theme, pressed, type }) =>
    pressed ? `background-color: ${`${theme.colors[type]}AA`};` : null}
  ${({ theme, disabled, disabledType }) =>
    disabled ? `background-color: ${theme.colors[disabledType]};` : null}
`

export type StyledTextButtonProps = StyledProps<{
  color: ThemeColor
  underline?: boolean
}>

export const StyledTextButton = styled(Text)<StyledTextButtonProps>`
  text-decoration-color: ${({ color, theme }) => theme.colors[color]};
  ${({ theme, bold }) => bold && `font-weight: bold`}
  ${({ theme, underline }) => underline && `text-decoration: underline`}
  ${({ theme, fontSize }) => (fontSize ? `font-size: ${theme.fonts.sizes[fontSize]}px;` : null)}
`
